import { ArrowRight, CalendarClock, FileWarning, PhoneCall } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { P2PDemoView } from '@/lib/p2pAppeals';

export function P2PResponseCard({
  view,
  onOpen,
}: {
  view: P2PDemoView;
  onOpen: () => void;
}) {
  return (
    <Card className="border-amber-300 bg-amber-50/70">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <CardTitle className="flex items-center gap-2 text-base text-amber-950">
              <FileWarning className="h-4 w-4 text-amber-700" />
              Payer denial received
            </CardTitle>
            <p className="mt-1 text-xs leading-5 text-amber-900/75">
              P2P review is available for {view.scenario.patientName}.
            </p>
          </div>
          <Badge className="shrink-0 bg-amber-700 text-white hover:bg-amber-700">P2P</Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2 text-sm text-amber-950">
          <div className="flex items-center gap-2">
            <PhoneCall className="h-4 w-4 text-amber-700" />
            <span className="font-medium">{view.scenario.payerName} / {view.scenario.umVendor}</span>
          </div>
          <div className="flex items-center gap-2">
            <CalendarClock className="h-4 w-4 text-amber-700" />
            <span>Call window closes {view.p2pDeadlineLabel}</span>
          </div>
        </div>

        <p className="line-clamp-3 text-xs leading-5 text-amber-900/80">
          {view.scenario.denialRationale}
        </p>

        <Button onClick={onOpen} className="w-full gap-2 bg-amber-700 text-white hover:bg-amber-800">
          Open P2P Call Prep
          <ArrowRight className="h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
}
